import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import WidgetProductNew from './WidgetProductNew';
import InfoModalComponent from '../../Common/InfoModalComponent';
import { removeDomainName } from '../../../../utils/helper';
import './Widget.scss';
import WidgetWrapper from '../NewProductWidget/WidgetWrapper';

class Widget extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      colorIndex: undefined,
      dittoFound: true,
      shortlistFull: false,
    };
    this.catImgPattern = /(thumbnail\/628x301\/)/gm;
    this.catImgSmall = 'thumbnail/628x301/';
    this.setHoverImage = this.setHoverImage.bind(this);
  }

  onImageError = (productData, evt) => {
    evt.target.src = productData.image_url;
    this.setState({
      dittoFound: false,
    });
  };

  setHoverImage = (action, event) => {
    const { productData } = this.props;
    if (action === 'ditto') return;
    let catImgSmall = null;
    if (typeof window !== 'undefined' && window.outerWidth > 1300) {
      catImgSmall = this.catImgSmall;
    } else {
      catImgSmall = 'thumbnail/371x178/';
    }
    if (action === 'enter') {
      event.target.src = productData.hover_image_url
        ? productData.hover_image_url.replace(this.catImgPattern, catImgSmall)
        : this.props.productData.image_url.replace(this.catImgPattern, catImgSmall);
    } else {
      event.target.src = productData.image_url.replace(this.catImgPattern, catImgSmall);
    }
  };

  mouseOutColor = () => {
    this.setState({
      colorIndex: undefined,
    });
  };

  mouseInColor = index => {
    this.setState({
      colorIndex: index,
    });
  };

  shortlistLimitReached = () => {
    this.setState({
      shortlistFull: !this.state.shortlistFull,
    });
  };

  isShortListErrWinClosed = () => {
    this.setState({ shortlistFull: false });
  };

  gaqEventsPush = (type, subType, params) => {
    _gaq.push(['_trackEvent', type, subType, params], ['ninja._trackEvent', type, subType, params]);
  };

  render() {
    const {
      productData,
      dittoEnable,
      colorOptions,
      setWishList,
      shortListData,
      login,
      redisCommonData,
      isTryOnSwitch,
      toggleTryOn,
      dataLocale,
      isExchange,
      localeInfo,
    } = this.props;
    const { DITTO_CONFIG, PRODUCT_OFFERID_CONFIG_DESKTOP, NEW_PLP_WIDGET } = redisCommonData || {};
    const dittoConfig = DITTO_CONFIG && JSON.parse(DITTO_CONFIG);
    const isTryOnSwitchCTA =
      dittoConfig &&
      dittoConfig.isDittoEnableGlobal === 'ON' &&
      ((!redisCommonData?.ENABLE_CYGNUS && productData.is_ditto) ||
        (redisCommonData?.ENABLE_CYGNUS && productData?.isCygnusEnabled));
    const { colorIndex, dittoFound, shortlistFull } = this.state;
    const productUrl = removeDomainName(productData.product_url, '', localeInfo?.countryCode);
    const productImage = productData.image_url
      ? productData.image_url.replace(this.catImgPattern, this.catImgSmall)
      : '';
    const { YOU_CAN_SHORTLIST_UPTO_50, SHORTLIST_LIMIT_REACHED, IMG } = dataLocale;

    if (typeof colorOptions[colorIndex] === 'undefined') {
      return (
        <div
          className="productWidgetBox border"
          onFocus={ev => this.setHoverImage('ditto', ev)}
          onMouseLeave={ev => this.setHoverImage('ditto', ev)}
          onMouseOver={ev => this.setHoverImage('ditto', ev)}
        >
          {shortlistFull && (
            <InfoModalComponent
              callback={() => {
                this.isShortListErrWinClosed();
              }}
              headerTitle={SHORTLIST_LIMIT_REACHED}
              msgContent={YOU_CAN_SHORTLIST_UPTO_50}
              msgType="info"
            />
          )}
          <div className="productWidgetBox_widgetImage">
            {productData.offer_image && (
              <span className="productWidgetBox_widgetImage_offerImage">
                <img alt={IMG} src={productData.offer_image} />
              </span>
            )}
            {NEW_PLP_WIDGET === 'ON' ? (
              <WidgetWrapper
                key="wp"
                PRODUCT_OFFERID_CONFIG_DESKTOP={PRODUCT_OFFERID_CONFIG_DESKTOP}
                catImgPattern={this.catImgPattern}
                catImgSmall={this.catImgSmall}
                colorObj={colorOptions[colorIndex]}
                colorOptions={colorOptions}
                dataLocale={dataLocale}
                dittoFound={dittoFound}
                gaqEventsPush={this.gaqEventsPush}
                isExchange={isExchange}
                isTryOnSwitch={isTryOnSwitch}
                isTryOnSwitchCTA={isTryOnSwitchCTA}
                login={login}
                mouseInColor={this.mouseInColor}
                mouseOutColor={this.mouseOutColor}
                productData={productData}
                productImage={productImage}
                productUrl={productUrl}
                setHoverImage={this.setHoverImage}
                setWishList={setWishList}
                shortListData={shortListData}
                shortlistLimitReached={this.shortlistLimitReached}
                showDitto={dittoEnable}
                toggleTryOn={toggleTryOn}
                onImageError={this.onImageError}
              />
            ) : (
              <WidgetProductNew
                key="wp"
                PRODUCT_OFFERID_CONFIG_DESKTOP={PRODUCT_OFFERID_CONFIG_DESKTOP}
                catImgPattern={this.catImgPattern}
                catImgSmall={this.catImgSmall}
                colorObj={colorOptions[colorIndex]}
                colorOptions={colorOptions}
                dataLocale={dataLocale}
                dittoFound={dittoFound}
                gaqEventsPush={this.gaqEventsPush}
                isExchange={isExchange}
                isTryOnSwitch={isTryOnSwitch}
                isTryOnSwitchCTA={isTryOnSwitchCTA}
                login={login}
                mouseInColor={this.mouseInColor}
                mouseOutColor={this.mouseOutColor}
                productData={productData}
                productImage={productImage}
                productUrl={productUrl}
                setHoverImage={this.setHoverImage}
                setWishList={setWishList}
                shortListData={shortListData}
                shortlistLimitReached={this.shortlistLimitReached}
                showDitto={dittoEnable}
                toggleTryOn={toggleTryOn}
              />
            )}
          </div>
        </div>
      );
    }

    return (
      <div
        className="productWidgetBox border"
        onFocus={ev => this.setHoverImage('ditto', ev)}
        onMouseLeave={ev => this.setHoverImage('ditto', ev)}
        onMouseOver={ev => this.setHoverImage('ditto', ev)}
      >
        {shortlistFull && (
          <InfoModalComponent
            callback={() => {
              this.isShortListErrWinClosed();
            }}
            headerTitle={SHORTLIST_LIMIT_REACHED}
            msgContent={YOU_CAN_SHORTLIST_UPTO_50}
            msgType="info"
          />
        )}
        <div className="productWidgetBox_widgetImage">
          {productData.offer_image && (
            <span className="productWidgetBox_widgetImage_offerImage">
              <img alt={IMG} src={productData.offer_image} />
            </span>
          )}
          {NEW_PLP_WIDGET === 'ON' ? (
            <WidgetWrapper
              key="wp"
              PRODUCT_OFFERID_CONFIG_DESKTOP={PRODUCT_OFFERID_CONFIG_DESKTOP}
              catImgPattern={this.catImgPattern}
              catImgSmall={this.catImgSmall}
              colorObj={colorOptions[colorIndex]}
              colorOptions={colorOptions}
              dataLocale={dataLocale}
              dittoFound={dittoFound}
              gaqEventsPush={this.gaqEventsPush}
              isExchange={isExchange}
              isTryOnSwitch={isTryOnSwitch}
              isTryOnSwitchCTA={isTryOnSwitchCTA}
              login={login}
              mouseInColor={this.mouseInColor}
              mouseOutColor={this.mouseOutColor}
              productData={productData}
              productImage={productImage}
              productUrl={productUrl}
              setHoverImage={this.setHoverImage}
              setWishList={setWishList}
              shortListData={shortListData}
              shortlistLimitReached={this.shortlistLimitReached}
              showDitto={dittoEnable}
              toggleTryOn={toggleTryOn}
              onImageError={this.onImageError}
            />
          ) : (
            <WidgetProductNew
              key="wp"
              PRODUCT_OFFERID_CONFIG_DESKTOP={PRODUCT_OFFERID_CONFIG_DESKTOP}
              catImgPattern={this.catImgPattern}
              catImgSmall={this.catImgSmall}
              colorObj={colorOptions[colorIndex]}
              colorOptions={colorOptions}
              dataLocale={dataLocale}
              dittoFound={dittoFound}
              gaqEventsPush={this.gaqEventsPush}
              isExchange={isExchange}
              isTryOnSwitch={isTryOnSwitch}
              isTryOnSwitchCTA={isTryOnSwitchCTA}
              login={login}
              mouseInColor={this.mouseInColor}
              mouseOutColor={this.mouseOutColor}
              productData={productData}
              productImage={productImage}
              productUrl={productUrl}
              setHoverImage={this.setHoverImage}
              setWishList={setWishList}
              shortListData={shortListData}
              shortlistLimitReached={this.shortlistLimitReached}
              showDitto={dittoEnable}
              toggleTryOn={toggleTryOn}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  shortListData: state.common.shortListData,
  redisCommonData: state.common.redisCommonData,
  isTryOnSwitch: state.common.isTryOnSwitch,
  localeInfo: state.common.localeInfo,
  dataLocale: state.locale,
});

export default connect(mapStateToProps)(Widget);
